import { useCallback, useEffect } from 'react'

export const useDocumentTitle = (title: string, defaultTitle = 'ElasticSales') => {
  useEffect(() => {
    document.title = `${title} | ${defaultTitle}`
    return () => {
      document.title = defaultTitle
    }
  }, [title, defaultTitle])

  return useCallback(
    (newTitle: string) => {
      document.title = `${newTitle} | ${defaultTitle}`
    },
    [defaultTitle],
  )
}
